module.exports = __webpack_public_path__ + "static/img/8.04bf63c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/8.jpg
// module id = zvCP
// module chunks = 0